import { Role } from 'api/models';
import * as yup from 'yup';

const { string, array } = yup;

export const getAddUserValidationSchema = (t: (key: string) => string) =>
  yup.object({
    email: string()
      .email(t('login.errors.email') ?? '')
      .required(t('general.errors.mandatoryField') ?? ''),
    roles: array().min(1, t('general.errors.mandatoryField') ?? ''),
    subProjectId: string().required(t('general.errors.mandatoryField') ?? ''),
  });

interface AddUserValues {
  email: string;
  roles: Role[];
  subProjectId?: string;
  userId: string;
}

export const initialAddUserValues: AddUserValues = {
  email: '',
  userId: '',
  roles: [],
  subProjectId: undefined,
};
